import React from 'react';
import {
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';

const UploadGroupItem = () => {
  const { resource } = useMetaLayoutContext();

  if (!resource) {
    return null;
  }

  return (
    <FDStack
      direction="row"
      alignItems="center"
      {...dataAttrs('upload-group-item', resource)}
    >
      <FDPaper width={'100%'} padding={1} margin={50} appearance={'flat'} color={'subtle'}>
        <MetaControlField attr="description" />
      </FDPaper>
    </FDStack>
  );
};

UploadGroupItem.propTypes = {};

UploadGroupItem.defaultProps = {};

export default UploadGroupItem;
